/** @format */

export const BrandLinks = {
  nike: '/f/nike-view-all',
  adidas: '/f/adidas-apparel-footwear',
  jordan: '/f/jordan',
  on: '/f/on-clothing-and-shoes',
  'new balance': '/f/new-balance-apparel-footwear',
  hoka: '/f/hoka-running-shoes',
  'under armour': '/f/under-armour-apparel-footwear',
  calia: '/f/calia-view-all',
  dsg: '/f/dsg-shop-the-collection',
  stanley: '/f/stanley',
} as const;
